var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFTwt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.979,
    height: 12.936,
    viewBox: "0 0 14.979 12.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval-1",
    d: "M21.273,18.941l.032.56-.541-.068a8.662,8.662,0,0,1-5.152-2.649l-.714-.742-.184.548a3.406,3.406,0,0,0,.671,3.38c.433.48.336.548-.411.263-.26-.091-.487-.16-.509-.126a4.242,4.242,0,0,0,.39,1.53A3.566,3.566,0,0,0,16.338,23.1l.53.263-.628.011c-.606,0-.628.011-.563.251A3.328,3.328,0,0,0,17.7,25.5l.671.24-.584.365a5.9,5.9,0,0,1-2.9.845,3.075,3.075,0,0,0-.887.091,8.082,8.082,0,0,0,2.089,1,8.8,8.8,0,0,0,7.1-.845,9.826,9.826,0,0,0,3.6-4.431,12.23,12.23,0,0,0,.736-3.426c0-.525.032-.594.639-1.222a7.358,7.358,0,0,0,.758-.879c.108-.217.1-.217-.455-.023-.92.343-1.05.3-.6-.217a3.35,3.35,0,0,0,.736-1.222c0-.034-.162.023-.346.126a5.883,5.883,0,0,1-.952.388l-.584.194-.53-.377a4.339,4.339,0,0,0-.92-.5,3.544,3.544,0,0,0-1.894.046,3.272,3.272,0,0,0-2.11,3.289Zm0,0",
    transform: "translate(-14 -15.5)",
    fill: "#312C40",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFTwt);
export default __webpack_public_path__ + "static/media/f-twt.2a1b37ba6452d54cc94e2fecf524edf1.svg";
export { ForwardRef as ReactComponent };